import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { CacheService } from 'src/app/services/cache.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { DataService } from 'src/app/services/data.service';
import { UrlConstants } from 'src/app/services/url-constants';
import { UserService } from 'src/app/services/user.service';
import { Auth, Hub } from 'aws-amplify';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-close-account',
  templateUrl: './close-account.component.html',
  styleUrls: ['./close-account.component.scss']
})
export class CloseAccountComponent implements OnInit {

  success: any = null;
  skeltonArray: any = [{}];
  isSkeltonLoad: boolean = true;
  isloading: boolean = false;
  userName: any;
  showconfirmModal: boolean = false;
  isRemoving: boolean = false;
  public confirmForm: UntypedFormGroup;
  emailUser: boolean = true;
  userEmail: any;
  errorText: string = 'Rejected';

  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 658 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `calc(${this.screenHeight}px - 100px )`;
    }
  }
  constructor(
    public userService: UserService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private authenticate: CacheService,
    public constants: ConstantsService,
    private fb: UntypedFormBuilder,
    private zone: NgZone,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.initialiseForm();
    this.authcall();
    this.onResize();
  }
  public async authcall() {
    // Get current user data from db for get the email and name
    await this.userService.getUser(false).then(res => {
      this.userName = res.userName;
      this.userEmail = res.email;
      if (this.userName.includes('google') || this.userName.includes('facebook')) {
        this.emailUser = false;
      }
    })
    this.isSkeltonLoad = false
  }
  initialiseForm = () => {
    this.confirmForm = this.fb.group({
      password: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=.*[$@#!%*?&])(?=[^A-Z]*[A-Z]).{8,}$/),
      ])
    })
  }
  async deleteAccount() {
    this.isRemoving = true;
    let user;
    if (!this.emailUser) {
      this.deleteAllUserDetails();
    } else {
      try {
        user = await Auth.signIn(this.userName, this.confirmForm.value.password);
      } catch (error) {
        if (error.message === "Incorrect username or password.") {
          this.errorText = 'Your email or password don’t match. Try again'
        }
        else {
          this.errorText = error.message
        }
        this.success = false;
        this.isRemoving = false;
        this.showconfirmModal = false;
        setTimeout(() => {
          this.success = null;
        }, 5000);
      }
      if (user) {
        this.deleteAllUserDetails();
      }

      return;
    }
  }
  async deleteAllUserDetails() {
    let markDelete;
    const params = [{ param: '{object}', value: 'user' }];
    const bodyObj = {
      "userName": this.userName,
      "email": this.userEmail
    };
    try {
      markDelete = await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj))
        .subscribe(async data => {
          this.logout();
          localStorage.removeItem('user')
          localStorage.removeItem('myWindowCache')
          localStorage.removeItem('bookmarked_Cache')
          localStorage.removeItem('PendingList')
          localStorage.removeItem('ApprovedCache')
          localStorage.removeItem('rejectedCache')
          this.isRemoving = false;
          this.router.navigate(['/'])
        }, err => {
          // console.log(err)
        })
    } catch (error) {
      this.errorText = error.message;
      this.success = false;
      this.isRemoving = false;
      this.showconfirmModal = false;
      setTimeout(() => {
        this.success = null;
      }, 5000);
      // console.log(error)
    }
  }
  onClickCloseConfirmPopup() {
    this.showconfirmModal = false;
  }
  openConfirmModal() {
    this.showconfirmModal = true;
  }
  async logout() {
    try {
      await await Auth.signOut()
      this.userService.userData = undefined;
      this.userService.isFirstCall = true;
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      if (error.code === 'NotAuthorizedException') {
        console.error('Access Token has been revoked. Please log in again.');
        localStorage.clear();
        // Optionally redirect to login or show a message to the user
        this.router.navigate(['/login']);
      } else {
        console.error('Error signing out:', error);
      }
    }
  }
}
